import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { axiosInstance, updatedAccessToken } from '../api';
import { ERROR, GET_ALL_REPORTS_SUCCESS, GET_CONDITION_OPTIONS_SUCCESS, GET_REPORT_BY_ID_SUCCESS, GET_ALL_REPORTS, GET_CONDITION_OPTIONS, GET_REPORT_BY_ID, LOADER, TOKEN_EXPIRED } from "../actions/types";

function getAllReportApiHandler(action) {
    let url = `reports?tab=${action.payload.tab}&useremail=${action.payload.email}`
    return axiosInstance.get(url, { headers: updatedAccessToken() })
}

function getAllConditionOptionsApiHandler(action) {
    let url = `reports/labels?tab=${action.payload.tab}`
    return axiosInstance.get(url, { headers: updatedAccessToken() })
}

function addReportApiHandler(action) {
    let url = `reports/add`
    return axiosInstance.post(url, { payload: action.payload, headers: updatedAccessToken() })
}

function getReportByIdHandlerApiHandler(action) {
    let url = `reports/detail?report_id=${action.payload.report_id}`
    return axiosInstance.get(url, { headers: updatedAccessToken() })
}

function* getAllReportHandler(action) {
    try {
        yield put({
            type: LOADER,
            payload: true,
        });
        const response = yield call(() => getAllReportApiHandler(action));
        if (response?.data?.statusCode === 200) {
            yield put({ type: GET_ALL_REPORTS_SUCCESS, response: response.data })
        } else {
            yield put({
                type: ERROR,
                payload: response.data.body.message,
            });
        }
        yield put({
            type: LOADER,
            payload: false,
        });
    } catch (err) {
        if (err.response?.status === 403) {

            yield put({
                type: TOKEN_EXPIRED,
                payload: true,
            });

            setTimeout(() => {
                window.location.reload();
            }, 3000)
        }
        else {
            yield put({
                type: ERROR,
                payload: err.message,
            });
        }
    }
}

function* getAllConditionOptionsHandler(action) {
    try {
        yield put({
            type: LOADER,
            payload: true,
        });
        const response = yield call(() => getAllConditionOptionsApiHandler(action));
        yield put({
            type: LOADER,
            payload: false,
        });
        if (response?.data?.statusCode === 200) {
            yield put({ type: GET_CONDITION_OPTIONS_SUCCESS, response: response.data })
        } else {
            yield put({
                type: LOADER,
                payload: false,
            });
            yield put({
                type: ERROR,
                payload: response.data.body.message,
            });
        }
    } catch (err) {

        if (err.response?.status === 403) {
            yield put({
                type: TOKEN_EXPIRED,
                payload: true,
            });

            setTimeout(() => {
                window.location.reload();
            }, 3000)
        }
        else {
            yield put({
                type: ERROR,
                payload: err.message,
            });
        }
    }
}

// function* addReportHandler(action) {
//     try {
//         const response = yield call(() => addReportApiHandler(action));
//         yield put({ type: 'ADD_REPORT_SUCCESS', response: response.data })
//     } catch (e) {
//         yield put({ type: 'ADD_REPORT_FAILED', message: e.message })
//     }
// }

function* getReportByIdHandler(action) {
    try {
        yield put({
            type: LOADER,
            payload: true,
        });
        const response = yield call(() => getReportByIdHandlerApiHandler(action));
        yield put({
            type: LOADER,
            payload: false,
        });
        if (response?.data?.statusCode === 200) {
            yield put({ type: GET_REPORT_BY_ID_SUCCESS, response: response.data })
        } else {
            yield put({
                type: LOADER,
                payload: false,
            });
            yield put({
                type: ERROR,
                payload: response.data.body.message,
            });
        }
    } catch (err) {

        if (err.response?.status === 403) {
            yield put({
                type: TOKEN_EXPIRED,
                payload: true,
            });

            setTimeout(() => {
                window.location.reload();
            }, 3000)
        }
        else {
            yield put({
                type: ERROR,
                payload: err.message,
            });
        }
    }
}


function* getAllReport() {
    yield takeLatest(GET_ALL_REPORTS, getAllReportHandler)
}

function* getAllConditionOptions() {
    yield takeLatest(GET_CONDITION_OPTIONS, getAllConditionOptionsHandler)
}

// function* addReport() {
//     yield takeEvery('ADD_REPORT', addReportHandler)
// }

function* getReportById() {
    yield takeLatest(GET_REPORT_BY_ID, getReportByIdHandler)
}

const reportSaga = {
    getAllReport: getAllReport(),
    getAllConditionOptions: getAllConditionOptions(),
    // addReport: addReport(),
    getReportById: getReportById()
}

export default reportSaga;